import { ApiOffline, ApiProblem } from '@/api/problem';
import { de } from '@/i18n/de';
import { format } from '@/i18n/format';
import { problemText } from '@/i18n/messages';
import { t } from '@/i18n/t';
import { Button } from '@/shell/ui/button';

/** Klartext zur Ursache; nie `detail` oder ein Stacktrace des Servers. */
function explanation(error: unknown): string | null {
  if (error instanceof ApiOffline) {
    return de.problem.offline;
  }
  if (!(error instanceof ApiProblem)) {
    return null;
  }
  const retryAt =
    error.retryAfterSeconds === null
      ? undefined
      : format.time(new Date(Date.now() + error.retryAfterSeconds * 1000));
  return problemText(error.code, { reason: error.reason, retryAt });
}

/**
 * Fehlerkarte eines Blocks: fester Satz, Ursache in Klartext, „Erneut versuchen“ und die Fehlernummer klein
 * darunter. Ein Fehler betrifft nur seinen Block ([A] 5.10).
 */
export function ErrorCard({ error, onRetry }: { error?: unknown; onRetry?: () => void }) {
  // Nur eine Nummer vom Server hilft beim Nachfragen; Fehler im Browser selbst haben keine (kein rohes „client“)
  const requestId =
    error instanceof ApiProblem && error.requestId !== 'client' && error.requestId !== ''
      ? error.requestId
      : null;
  const cause = explanation(error);
  return (
    <div
      role="alert"
      className="grid justify-items-start gap-2 rounded-surface border border-line bg-surface-block p-5"
    >
      <p className="text-lead font-semibold text-ink">{de.states.errorTitle}</p>
      {cause === null ? null : <p className="text-body text-ink-muted">{cause}</p>}
      {onRetry === undefined ? null : (
        <Button variant="secondary" onClick={onRetry}>
          {de.states.retry}
        </Button>
      )}
      {requestId === null ? null : (
        <p className="text-fine text-ink-muted">{t('states.requestId', { requestId })}</p>
      )}
    </div>
  );
}
